const LOGIN_CHECK_KEY = 'loginCheckPassword';
const PENDING_KEY = 'passwordChangePending';

const storage = () => {
  try {
    return sessionStorage;
  } catch (e) {
    return null;
  }
};

export const markLoginPasswordCheck = () => {
  storage()?.setItem(LOGIN_CHECK_KEY, '1');
};

export const clearLoginPasswordCheck = () => {
  storage()?.removeItem(LOGIN_CHECK_KEY);
};

export const isLoginPasswordCheck = () => storage()?.getItem(LOGIN_CHECK_KEY) === '1';

export const setPasswordChangePending = () => {
  storage()?.setItem(PENDING_KEY, '1');
};

export const isPasswordChangePending = () => storage()?.getItem(PENDING_KEY) === '1';

export const clearPasswordChangePending = () => {
  storage()?.removeItem(PENDING_KEY);
};
